<template>
  <div class="container link">
    <div class="link__title-container">
      <div class="link__title-left" />
      <div class="link__title-right">
        <div class="">
          <div
            v-tooltip.bottom-start="{content: 'Modifications', ...tooltipOptions}"
            class="link__tab"
            @click="$refs.select.open()"
          >
            <base-select
              id="add-tab-dropdown"
              ref="select"
              :is-hide-arrow="true"
              :options="dataModalOptions"
              align-left
              :title-style="{'padding-left': '5px', 'font-size': '12px', 'font-weight': '900'}"
              :header-style="{height: '20px !important'}"
              :prop-list-style="{cursor: 'pointer'}"
              show-top-border
              :max-height-list="500"
              :placeholder-icon="'plusCircle'"
              :border-less="true"
              :placeholder-style="{'font-size':'20px', 'color': '#011627', 'padding': '0px'}"
              @change="$modal.show($event)"
            />
          </div>
        </div>
        <div class="">
          <div class="link__tab" @click="$modal.show('bulk-update')"
               v-tooltip.bottom-start="{content: 'Bulk Update', ...tooltipOptions}">
            <base-material-design-icon icon="flash" class="urlc__icon" />
          </div>
        </div>
        <div class="">
          <div
            v-tooltip.bottom-start="{content: 'Column Editor', ...tooltipOptions}"
            class="link__tab"
            @click="$modal.show('column-editor')"
          >
            <base-material-design-icon
              icon="tableColumnPlusAfter"
              class="link__icon"
            />
          </div>
        </div>
        <base-select
          v-model="pageItemsLimit"
          :options="paginationOptions"
          align-left
          :title-style="{'padding-left': '5px'}"
          :header-style="{backgroundColor: '#ffffff'}"
          show-top-border
          shift-label-right
          :select-style="{'margin': '5px', 'height': '34px !important', width: '100px !important'}"
          :prop-list-style="{cursor: 'pointer'}"
        />
      </div>
    </div>

    <template v-if="!enabledColumns.length">
      <div class="no-data-block link__wait-columns">
        Toggle columns for the table view
      </div>
    </template>
    <div v-else>
      <div ref="table" />
    </div>
    <div
      v-if="isDataUpdating"
      class="link__update-loader"
    >
      <base-loader class="link__update-loader-ring" />
    </div>
    <modal
      name="bulk-update"
      v-bind="modalProps"
    >
      <base-bulk-update
        ref="bulk-update"
        :selected-ids="selectedIds"
        :columns="bulkUpdateOptions"
        @close="$modal.hide('bulk-update')"
        @apply="applyBulkUpdateLinks"
      />
    </modal>

    <modal
      name="quick-add"
      v-bind="modalProps"
    >
      <base-quick-add
        ref="quick-add"
        title="Links"
        :columns="quickAddOptions"
        @close="$modal.hide('quick-add')"
        @apply="applyQuickAddLinks"
      />
    </modal>
    <modal
      name="column-editor"
      v-bind="modalProps"
    >
      <base-tabulator-column-editor
        ref="column-editor"
        :table="tabulator"
        :hidden-columns="['edit-button']"
        @close="$modal.hide('column-editor')"
      />
    </modal>
    <modal
      name="create"
      v-bind="changeLinkModalProps"
    >
      <CreateUpdateLinkPopup
        ref="create-link"
        :selected-link="selectedLink"
        :attachments.sync="attachments"
        :opts="opts"
        @apply="createOrUpdateLink($event)"
        @applyAttachment="applyAttachment($event)"
        @delete="deleteLink($event)"
        @deleteAttachment="deleteAttachment($event)"
        @downloadAttachment="downloadAttachment($event)"
        @cancel="closeCreateModal"
      />
    </modal>
    <base-material-design-icon
      ref="iconPencil"
      style="font-size:14px;"
      icon="edit"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Tabulator from 'tabulator-tables'
// import BaseTabulatorColumnEditor from '@/common/BaseTabulatorColumnEditor'
// import BaseQuickAddModal from '@/common/BaseQuickAddModal'
import baseModalProps from '@/common/BaseModalProps'
import CreateUpdateLinkPopup from './CreateUpdateLinkPopup'
import ToasterService from '@/services/toasterService'
import _ from 'lodash'
import BaseSortMixins from '@/common/BaseSortMixins'
import helper from '@/services/Helper'

const ITEMS_PER_PAGE = 10
const EMPTY_FILTERS = {
  is_active: [],
  sort_column: [],
  sort_order: [],
  page_from: 0,
  page_to: ITEMS_PER_PAGE
}
const PAGINATION_OPTIONS = [
  {
    label: '10',
    value: 10
  },
  {
    label: '25',
    value: 25
  },
  {
    label: '50',
    value: 50
  }
]
// table config
const DEFAULT_CONFIG = [
  {
    label: '',
    property: 'edit-button'
  },
  {
    label: 'Link Type',
    property: 'link_type',
    propName: 'link_type'
  },
  {
    label: 'Status',
    property: 'status',
    propName: 'status'
  },
  {
    label: 'Publisher URL',
    property: 'publisher_url',
    propName: 'publisher_url'
  },
  {
    label: 'Target URL',
    property: 'target_url',
    propName: 'target_url'
  },
  {
    label: 'Publish Date',
    property: 'publish_date',
    propName: 'publish_date'
  },
  {
    label: 'DA',
    property: 'domain_authority',
    propName: 'domain_authority'
  },
  {
    label: 'TF',
    property: 'trust_flow',
    propName: 'trust_flow'
  },
  {
    label: 'CF',
    property: 'citation_flow',
    propName: 'citation_flow'
  },
  {
    label: 'TF Ratio',
    property: 'tf_ratio',
    propName: 'tf_ratio'
  },
  {
    label: 'Has Featured Image',
    property: 'has_featured_image',
    propName: 'has_featured_image'
  },
  {
    label: 'State',
    property: 'state',
    propName: 'state',
    visible: false
  },
  {
    label: 'Client Inv.',
    property: 'client_invoice',
    propName: 'client_invoice',
    visible: false
  },
  {
    label: 'Client SOW',
    property: 'client_sow',
    propName: 'client_sow',
    visible: false
  },
  {
    label: 'Agent',
    property: 'agent',
    propName: 'agent',
    visible: false
  },
  {
    label: 'Agent order #',
    property: 'agent_order_record',
    propName: 'agent_order_record',
    visible: false
  },
  {
    label: 'Agent assign. date',
    property: 'agent_assignment_date',
    propName: 'agent_assignment_date',
    visible: false
  },
  {
    label: 'Agent target date',
    property: 'agent_target_date',
    propName: 'agent_target_date',
    visible: false
  }
]
// Set Status to ‘Published’
// Set Linktype to ‘Editorial’

const DEFAULT_SELECTED_COLUMNS = ['is_active', 'link_type', 'status', 'publisher_url', 'target_url', 'publish_date', 'domain_authority', 'trust_flow', 'citation_flow', 'tf_ratio', 'has_featured_image']

export default {
  name: 'Links',
  components: { CreateUpdateLinkPopup },
  mixins: [BaseSortMixins],
  data () {
    return {
      bulkUpdateOptions: [
        {
        title: 'Status',
        options: []
        },
        {
        title: 'Link Type',
        options: []
        }
      ],
      quickAddOptions: [
        {
        title: 'URL',
        required: true,
        editor: 'autocomplete',
        formatter: 'lookup',
        editorParams: { freetext: false },
        minWidth: 300
        },
        {
        title: 'Page Title'
        },
        {
        title: 'Anchor Text'
        },
        {
        title: 'Publisher URL',
        required: true,
        validateUrl: true,
        minWidth: 300
        },
        {
        title: 'Publish Date',
        required: true,
        editor: 'date'
        },
        {
        title: 'DA',
        editor: 'number',
        validator: ['min:0', 'max:100'],
        editorParams: {
            min: 0,
            max: 100
          }
        },
        {
        title: 'TF',
        editor: 'number',
        validator: ['min:0', 'max:100'],
        editorParams: {
            min: 0,
            max: 100
          }
        }
      ],
      dataModalOptions: [
        {
          label: 'Create Link',
          value: 'create'
        },
        {
          label: 'Add Links',
          value: 'quick-add'
        },
      ],
      tabulator: null,
      isDataFetched: false,
      isHeaderOpened: false,
      selectedLink: null,
      attachments: [],
      isDataUpdating: false,
      sortConfig: [],
      tableColumns: [],
      columnsDefaultState: [...DEFAULT_SELECTED_COLUMNS],
      enabledColumns: [...DEFAULT_SELECTED_COLUMNS],
      pageItemsLimit: ITEMS_PER_PAGE,
      filterParams: _.cloneDeep(EMPTY_FILTERS),
      sortableHeaderRefs: {
        'is_active': 'is_active',
        'link_type': 'link_type',
        'status': 'status',
        'state': 'state',
        'client_invoice': 'client_invoice',
        'client_sow': 'client_sow',
        'agent': 'agent',
        'agent_order_record': 'agent_order_record',
        'agent_assignment_date': 'agent_assignment_date',
        'agent_target_date': 'agent_target_date',
        'publisher_url': 'publisher_url',
        'target_url': 'target_url',
        'publish_date': 'publish_date',
        'domain_authority': 'domain_authority',
        'trust_flow': 'trust_flow',
        'citation_flow': 'citation_flow',
        'tf_ratio': 'tf_ratio',
        'has_featured_image': 'has_featured_image'
      },
      paginationOptions: _.cloneDeep(PAGINATION_OPTIONS),
      opts: {}
    }
  },
  computed: {
    ...mapState('linksCrud', ['links']),
    selectedIds () {
      return this.tabulator ? this.tabulator.getSelectedData().map(row => row.id) : []
    },
    dataMissing () {
      return this.isDataFetched && !this.paginatedKeywords.length
    },
    isHeaderScrollable () {
      return this.dataMissing && !this.isHeaderOpened
    },
    changeLinkModalProps: function () {
      const changeLinkModalProps = {
        width: 690
      }
      return { ...baseModalProps, ...changeLinkModalProps }
    },
    modalProps () {
      const modalProps = {
        width: '75%'
      }
      return { ...baseModalProps, ...modalProps }
    },
    columnOptions () {
      const tableConfig = _.cloneDeep(DEFAULT_CONFIG)
      return tableConfig.filter(i => !['edit-button'].includes(i.property)).map(i => ({ label: i.label, value: i.property }))
    },
    linksTableColumnsConfig () {
      const defaultConfig = _.cloneDeep(DEFAULT_CONFIG)

      return defaultConfig.filter(i => this.enabledColumns.includes(i.property) || ['edit-button'].includes(i.property))
    },
    hasPagination () {
      return (this.isDataFetched && !this.isDataUpdating) && this.totalItems > this.pageItemsLimit
    },
    totalItems () {
      return this.links.length
    },
    paginatedKeywords () {
      let links = _.cloneDeep(this.links)
      const { page_from = 0, page_to = 10 } = this.filterParams
      return helper.sortByMultipleParams(links, this.sortConfig).slice(page_from, page_to)
    }
  },
  watch: {
    links: {
      handler (newData) {
        this.tabulator.replaceData(newData)
      },
      deep: true
    },
    pageItemsLimit (v) {
      this.tabulator.setPageSize(v) 
    },
    clientId: {
      handler (v) {
        v && this.loadData()
      },
      immediate: true
    },
    sortConfig: {
      handler (v) {
        this.filterParams = {
          ...this.filterParams,
          sort_column: v.map(item => item.propertyName),
          sort_order: v.map(item => item.sortDirection)
        }
      },
      deep: true
    }
  },
  mounted () {
    const rawIconPencilHtmlString = this.$refs.iconPencil.$el.outerHTML.toString()
    this.$refs.iconPencil.$el.parentNode.removeChild(this.$refs.iconPencil.$el)
    const columns = _.cloneDeep(DEFAULT_CONFIG).map(col => {
      col.title = col.label
      col.field = col.property
      return col
    })
    const handleOpenEdit = (e, cell) => {
      this.openCreateModal(cell._cell.row.data.id)
    }
    const editButtonColumn = columns.find(col => col.field === 'edit-button')
    editButtonColumn.cellClick = handleOpenEdit
    editButtonColumn.formatter = () => {
      return rawIconPencilHtmlString
    }
    this.tabulator = new Tabulator(this.$refs.table, {
      data: this.links, //link data to table
      reactiveData: true, //enable data reactivity
      columns: columns, //define table columns
      autoResize: true,
      layout: 'fitColumns',
      selectable: true,
      resizableColumns: true,
      movableColumns: false,
      headerSortTristate: true,
      headerSortElement: "<i class='fas fa-caret-up'></i>",
      pagination: 'local',
      paginationSize: this.pageItemsLimit,
      persistenceID: 'link_table',
      persistenceMode: 'local',
      persistence: {
        columns: ['width', 'visible', 'frozen']
      },
    })
    this.tableColumns = this.tabulator.getColumns()
  },
  methods: {
    ...mapActions('linksCrud', ['getLinkData', 'updateLinks', 'createLinks', 'createLink', 'deleteLinkById', 'updateLink', 'getLinkOptions', 'uploadAttachment', 'getLinkAttachments', 'deleteAttachmentById', 'downloadAttachmentById']),
    ...mapActions('webProperty', ['getWebProperties']),
    async loadData () {
      this.isDataUpdating = true
      let [opts] = await Promise.all([
        this.getLinkOptions({ clientId: this.clientId }),
        this.getLinkData({ clientId: this.clientId }),
        this.getWebProperties({ clientId: this.clientId })
        ])
      this.isDataUpdating = false
      if (opts) {
        this.opts = opts
        this.isDataFetched = true
        this.quickAddOptions[0].options = opts.url_id_opts.slice(1)
        this.quickAddOptions[0].formatterParams = opts.url_id_opts.reduce((previous, current) => {
          previous[current.value] = current.label
          return previous
        }, {})
        this.bulkUpdateOptions[0].options = opts.status_id_opts.slice(1)
        this.bulkUpdateOptions[1].options = opts.category_id_opts.slice(1)
      }
    },
    async applyBulkUpdateLinks (formData) {
      this.isDataUpdating = true
      try {
        await this.updateLinks({ clientId: this.clientId, data: formData })
        this.$modal.hide('bulk-update')
        this.getLinkData({ clientId: this.clientId })
      } catch (e) {
        if (e.length) {
          e.forEach(i => { ToasterService.showToast(ToasterService.ERROR_TYPE, i) })
        } else {
          ToasterService.showToast(ToasterService.ERROR_TYPE, e)
        }
      } finally {
        this.isDataUpdating = false
      }
    },
    async applyQuickAddLinks (formData) {
      this.isDataUpdating = true
      try {
        await this.createLinks({ clientId: this.clientId, data: formData })
        this.$modal.hide('quick-add')
        this.getLinkData({ clientId: this.clientId })
      } catch (e) {
        if (e.length) {
          e.forEach(i => { ToasterService.showToast(ToasterService.ERROR_TYPE, i) })
        } else {
          ToasterService.showToast(ToasterService.ERROR_TYPE, e)
        }
      } finally {
        this.isDataUpdating = false
      }
    },
    onToggleState (isHeaderOpened) {
      this.isHeaderOpened = isHeaderOpened
    },
    reset () {
      this.sortConfig = []
      this.setupFilterParams()
      this.loadPageData()
    },
    setupFilterParams () {
      if (!this.filters || this.isQueryFiltersApplied) {
        this.filterParams = { ...this.filterParams, ..._.cloneDeep(EMPTY_FILTERS) }
        return true
      }
      const filters = JSON.parse(this.filters)
      this.filterParams = _.cloneDeep({ ...this.filterParams, ...EMPTY_FILTERS, ...filters })
      if (filters.sort_column && filters.sort_column.length > 0) {
        filters.sort_column.forEach((columnName, index) => {
          const propertyName = columnName
          const sortDirection = filters.sort_order[index]
          this.sortConfig.push({ propertyName, sortDirection })
        })
      }
      this.isQueryFiltersApplied = true
      return true
    },
    pageChanged ({ from, to }) {
      this.filterParams.page_from = from
      this.filterParams.page_to = to
    },
    async createOrUpdateLink (link) {
      this.isDataUpdating = true
      let isError = false
      try {
        if (link.id && link.id > -1) {
          await this.updateLink({ clientId: this.clientId, link }).catch(e => {
            isError = true
            this.$refs['create-link'].showErrors(e[0])
          })
        } else {
          await this.createLink({ clientId: this.clientId, link }).catch(e => {
            isError = true
            this.$refs['create-link'].showErrors(e[0])
          })
        }
        if (!isError) {
          await this.loadFilteredData()
          this.closeCreateModal()
        }
      } catch (e) {
        this.$refs['create-link'].showErrors(e[0])
      } finally {
        this.isDataUpdating = false
      }
    },
    getHeaderStyle (prop) {
      if (prop !== 'edit-button') {
        return null
      }
      return !this.enabledColumns.includes('is_active') ? { flex: '0 0 66px' } : null
    },
    async applyAttachment (attachmentData) {
      this.isDataUpdating = true
      try {
        await this.uploadAttachment(attachmentData)
        const linkAttachments = await this.getLinkAttachments(attachmentData.get('link_id'))
        if (linkAttachments) {
          this.attachments = linkAttachments.data
        }
      } catch (e) {
        this.$refs['create-link'].showErrors(e[0])
      } finally {
        this.isDataUpdating = false
      }
    },
    async deleteAttachment (attachmentId) {
      this.isDataUpdating = true
      try {
        await this.deleteAttachmentById(attachmentId)
        const linkAttachments = await this.getLinkAttachments(this.selectedLink.id)
        if (linkAttachments) {
          this.attachments = linkAttachments.data
        }
      } catch (e) {
        this.$refs['create-link'].showErrors(e[0])
      } finally {
        this.isDataUpdating = false
      }
    },
    async downloadAttachment (id) {
      this.isDataUpdating = true
      const downloadComplete = await this.downloadAttachmentById(id)
      if (downloadComplete) {
        this.isDataUpdating = false
      }
    },
    async deleteLink (linkId) {
      this.isDataUpdating = true
      try {
        await this.deleteLinkById({ clientId: this.clientId, id: linkId })
        await this.loadFilteredData()
        this.closeCreateModal()
      } catch (e) {
        this.$refs['create-link'].showErrors(e[0])
      } finally {
        this.isDataUpdating = false
      }
    },
    closeCreateModal () {
      this.selectedLink = null
      this.$modal.hide('create')
    },
    async openCreateModal (linkId) {
      if (linkId) {
        this.isDataUpdating = true
        this.selectedLink = this.links.find(link => link.id === linkId)
        const linkAttachments = await this.getLinkAttachments(linkId)
        if (linkAttachments) {
          this.attachments = linkAttachments.data
          this.isDataUpdating = false
        }
      }
      this.$modal.show('create')
    },
    handleLimitChange (value) {
      this.pageItemsLimit = value
      this.filterParams = { ...this.filterParams, page_from: 0, page_to: value }
    },
    filterColumn: function (event, column) {
      this.filterParams[column.property] = event
      this.filterParams.page_from = 0
      this.filterParams.page_to = this.pageItemsLimit
      this.loadFilteredData()
    },
    onHeaderSorting (cell, direction) {
      if (direction === 'clear') {
        this.sortConfig.shift()
        return
      }
      if (this.sortConfig.length) {
        this.sortConfig[0].propertyName = cell.property
        this.sortConfig[0].sortDirection = direction
      } else if (cell) {
        this.sortConfig = [{
          sortDirection: direction,
          propertyName: cell.property
        }]
      }
    },
    cancelSortingAndFilters () {
      this.filterParams = { ...EMPTY_FILTERS, page_to: this.pageItemsLimit }
      this.sortConfig = []
      !this.isDataUpdating && this.loadFilteredData()
    },
    async loadFilteredData () {
      this.isDataUpdating = true
      let [opts] = await Promise.all([
        this.getLinkOptions({ clientId: this.clientId }),
        this.getLinkData({
          clientId: this.clientId,
          filters: {
            ...this.filterParams,
            is_active: this.filterParams.is_active.includes(-1) ? [...this.filterParams.is_active, 0] : [...this.filterParams.is_active]
          }
        })
      ])
      if (opts) {
        this.opts = opts
        this.isDataFetched = true
      }
      this.isDataUpdating = false
    },
    cancelFilter (event, column) {
      this.filterParams[column.property] = null
      this.loadFilteredData()
    }
  },
  
}
</script>

<style scoped lang="scss">
#add-tab-dropdown {
  height: 20px !important;
  padding: 1px;
  cursor: pointer;
}

.common-table {
  background-color: $rfx-background-color;

  &__with-data {
    min-height: 350px;
    overflow-x: scroll;
  }

  &__row {
    background-color: #fff;
    border-bottom: 1px solid $rfx-light-steel;
    border-left: 1px solid $rfx-light-steel !important;
    border-right: 1px solid $rfx-light-steel !important;
  }

  &::-webkit-scrollbar {
    visibility: hidden;
  }

  & > div {
    &:last-child {
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }

  &__header {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    background-color: #dbdfe5 !important;

    &_scrollable {
      overflow-x: scroll;
    }
  }

  &__header-cell {
    background-color: #dbdfe5 !important;
    color: $rfx-dark-march;
    font-weight: bold;
    padding: 0;
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  &__cell {
    background-color: #fff;
    color: $rfx-dark-march !important;
    height: 60px;
    padding: 0;
    display: flex;
    align-items: center;
    font-size: 12px;
    padding-left: 14px;

    &:first-child {
      padding-left: 25px;
    }

  }

}

.link {
  position: relative;
  min-height: 200vh !important;

  &__wait-columns {
    background: white;
    height: 300px;
    border-bottom: none;
  }

  &__keyword-header {
    background-color: rgba(1, 22, 39, 0.1);
  }

  &__cross {
    font-size: 21px;
    margin-left: 5px;
    margin-top: -2px;
  }

  &__title-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    // flex: 1 1 50%;
    height: 60px;

    &_multi-select {
      align-self: flex-end
    }
  }

  &__title-left {
    display: flex;
    align-items: center;
  }

  &__title-left > *:not(:last-child) {
    margin-right: 30px;
  }

  &__header-button-wrapper {
    border-radius: 15px;
    border: solid 1px $rfx-light-steel;
    background: white;
    height: 28px;
    display: flex;
    padding: 0 10px;
  }

  &__copy-button {
    flex: 1 1 50%;
    height: 100%;
    border: none;
    outline: none;
    color: $rfx-dark-march;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 90px;
    background-color: #fff;
    font-size: 11px;

    &:hover {
      opacity: 0.5;
    }
  }

  &__clear-filters {
    @extend .link__copy-button;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: auto;

  }

  &__sortable-column {
    padding-left: 14px;
  }

  &__grid-select {
    flex-basis: 100px;
  }

  &__title-container {
    padding: 14px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__loader {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 530px);
  }

  &__table {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  &__update-loader {
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    background-color: white;
    top: 0;
    opacity: 0.5;
    z-index: 10000;
  }

  &__update-loader-ring {
    margin-top: 200px;
  }

  &__links {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }

  &__edit-button {
    flex: 0 0 45px;

    &.common-table__header-cell {
      flex: 0;
    }
  }

  &__link_type,
  &__agent,
  &__agent_order_record,
  &__agent_assignment_date,
  &__agent_target_date,
  &__publish_date,
  &__domain_authority,
  &__trust_flow,
  &__citation_flow,
  &__has_featured_image {
    flex: 0 0 180px;

    &.common-table__cell {
      flex-basis: 166px;
    }
  }

  &__link_type,
  &__status,
  &__state,
  &__client_invoice,
  &__client_sow,
  &__agent,
  &__agent_order_record {
    flex: 0 0 130px;

    &.common-table__cell {
      flex-basis: 115px;
    }
  }

  &__tf_ratio {
    flex: 0 0 110px;

    &.common-table__cell {
      flex-basis: 96px;
    }
  }

  &__domain_authority,
  &__trust_flow,
  &__citation_flow {
    flex: 0 0 80px;

    &.common-table__cell {
      flex-basis: 66px;
    }
  }

  &__publisher_url,
  &__target_url {
    flex: 0 0 600px;

    &.common-table__cell {
      flex-basis: 587px;
    }
  }

  &__is_active {
    flex: 0 0 119px;

    &.common-table__header-cell {
      flex-basis: 200px;

      &::v-deep .multi-select__title-container {
        padding-left: 69px !important;
      }
    }
  }

  &__button {
    width: 136px;
    padding: 0 20px;
    height: 60px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 900;
    text-transform: uppercase;
    border: none;
    outline: none;
    cursor: pointer;
    background-color: $rfx-medium-march;
    color: #fff;
    margin-left: 20px;
  }

  &__count {
    color: #b2b9be;
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
    width: 75px;
    white-space: nowrap;
  }

  &__tabs {
      display: grid;
      width: 50%;
      margin: 5px 0;
      border: 1px solid $rfx-light-steel;
      border-radius: 4px;
      height: 40px;
      flex: 15%;
      height: 34px;
      &.page-tabs {
        grid-template-columns: 1fr;
      }
  }

  &__tab {
      font-weight: 500;
      outline: none;
      font-size: 10px;
      border: 1px solid $rfx-light-steel;
      color: $rfx-dark-march;
      margin: 0;
      cursor: pointer;
      transition: box-shadow .3s;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      text-decoration: none;
      padding: 5px;

      &:hover{
                /* box-shadow: 0 0 11px 5px rgba(33,33,33,.2); */
                background-color: rgba(1, 22, 39, 0.1);
                opacity: 1;

      }

      &_center {
                border-left: 1px solid $rfx-light-steel;
                border-right: 1px solid $rfx-light-steel;
      }

      &_disabled {
        pointer-events: none;
        cursor: default;
      }

      &_active {
          background-color: rgba(1, 22, 39, 0.1);
          opacity: 1;
      }

      &__enabled {
          color: $rfx-bright-blue
      }
  }
}

.pagination-wrapper {
  display: flex;
  height: 60px;
  margin-top: 10px;
  justify-content: center;
  align-items: center;
  border: 1px solid $rfx-light-steel;
  border-radius: 4px;
}

.no-data-block {
  min-height: 250px;
  border-bottom: 1px solid $rfx-light-steel;
}

.common-table {
  &__header-cell {
    color: $rfx-dark-march;
    font-weight: bold;
  }
}

.edit-icon {
  cursor: pointer;
  font-size: 20px;
  justify-self: end;
  display: grid;
  color: $rfx-dark-march;
}

</style>
